<template>
    <rkm-area
        title="Cadastro de supervisor"
        type="fieldset"
    >
        <rkm-button
            @click="$refs.Modal.open()"
            color="primary"
            slot="trailing"
            small
            title="Adicionar supervisor"
        >
            <rkm-icon icon="plus" />
        </rkm-button>

        <Form :data="data" />

        <Modal
            :data="data"
            ref="Modal"
        />
    </rkm-area>
</template>

<script>
// Components.
import Form from './Form'
import Modal from './components/Modal'

export default {
    components: { Form, Modal },
    props: {
        data: { type: Object, required: true },
    },
}
</script>